/**
 * Acties die de gebruiker uitvoert.
 *
 * Gegenereerd bij de Hugeicons-migratie; handmatig uitbreiden mag.
 * Voeg een icoon hier toe, nooit rechtstreeks `@hugeicons/*` in een component.
 */
import {
    Archive02Icon,
    ArrowTurnBackwardIcon,
    ArrowTurnForwardIcon,
    Cancel01Icon,
    CheckListIcon,
    ClipboardCheckIcon,
    CloudUploadIcon,
    Copy01Icon,
    Delete02Icon,
    Download04Icon,
    Edit02Icon,
    FilterHorizontalIcon,
    FilterIcon,
    FloppyDiskIcon,
    HistoryIcon,
    MagicWand01Icon,
    MinusSignIcon,
    PackageIcon,
    PlusSignCircleIcon,
    PlusSignIcon,
    PowerServiceIcon,
    PowerSocket01Icon,
    PrinterIcon,
    RefreshIcon,
    RepeatIcon,
    Search01Icon,
    SearchVisualIcon,
    SentIcon,
    Settings02Icon,
    Share01Icon,
    ToggleOffIcon,
    Upload04Icon,
    ViewIcon,
    ViewOffSlashIcon,
} from "@hugeicons/core-free-icons";

import { createIcon } from "./create-icon";

export const Archive = createIcon(Archive02Icon, "Archive");
export const Boxes = createIcon(PackageIcon, "Boxes");
export const CirclePlus = createIcon(PlusSignCircleIcon, "CirclePlus");
export const ClipboardCheck = createIcon(ClipboardCheckIcon, "ClipboardCheck");
export const Copy = createIcon(Copy01Icon, "Copy");
export const Copy01 = createIcon(Copy01Icon, "Copy01");
export const Download = createIcon(Download04Icon, "Download");
export const Download01 = createIcon(Download04Icon, "Download01");
export const Edit01 = createIcon(Edit02Icon, "Edit01");
export const Edit04 = createIcon(Edit02Icon, "Edit04");
export const Eye = createIcon(ViewIcon, "Eye");
export const EyeOff = createIcon(ViewOffSlashIcon, "EyeOff");
export const Filter = createIcon(FilterIcon, "Filter");
export const FilterLines = createIcon(FilterHorizontalIcon, "FilterLines");
export const History = createIcon(HistoryIcon, "History");
export const ListChecks = createIcon(CheckListIcon, "ListChecks");
export const Minus = createIcon(MinusSignIcon, "Minus");
export const Pencil = createIcon(Edit02Icon, "Pencil");
export const Plus = createIcon(PlusSignIcon, "Plus");
export const Power = createIcon(PowerServiceIcon, "Power");
export const PowerOff = createIcon(PowerSocket01Icon, "PowerOff");
export const Printer = createIcon(PrinterIcon, "Printer");
export const RefreshCcw02 = createIcon(RefreshIcon, "RefreshCcw02");
export const RefreshCw = createIcon(RefreshIcon, "RefreshCw");
export const RefreshCw01 = createIcon(RefreshIcon, "RefreshCw01");
export const Repeat = createIcon(RepeatIcon, "Repeat");
export const Repeat2 = createIcon(RepeatIcon, "Repeat2");
export const RotateCcw = createIcon(ArrowTurnBackwardIcon, "RotateCcw");
export const RotateCw = createIcon(ArrowTurnForwardIcon, "RotateCw");
export const Save = createIcon(FloppyDiskIcon, "Save");
export const ScanSearch = createIcon(SearchVisualIcon, "ScanSearch");
export const Search = createIcon(Search01Icon, "Search");
export const SearchLg = createIcon(Search01Icon, "SearchLg");
export const Send = createIcon(SentIcon, "Send");
export const Settings = createIcon(Settings02Icon, "Settings");
export const Settings01 = createIcon(Settings02Icon, "Settings01");
export const Settings2 = createIcon(Settings02Icon, "Settings2");
export const Share2 = createIcon(Share01Icon, "Share2");
export const ToggleLeft = createIcon(ToggleOffIcon, "ToggleLeft");
export const Trash01 = createIcon(Delete02Icon, "Trash01");
export const Trash2 = createIcon(Delete02Icon, "Trash2");
export const Undo2 = createIcon(ArrowTurnBackwardIcon, "Undo2");
export const Upload = createIcon(Upload04Icon, "Upload");
export const UploadCloud = createIcon(CloudUploadIcon, "UploadCloud");
export const UploadCloud02 = createIcon(CloudUploadIcon, "UploadCloud02");
export const Wand2 = createIcon(MagicWand01Icon, "Wand2");
export const WandSparkles = createIcon(MagicWand01Icon, "WandSparkles");
export const X = createIcon(Cancel01Icon, "X");
export const XClose = createIcon(Cancel01Icon, "XClose");
